import { render, staticRenderFns } from "./TopFiveActiveSchools.vue?vue&type=template&id=4a693e9a&scoped=true"
import script from "./TopFiveActiveSchools.vue?vue&type=script&lang=js"
export * from "./TopFiveActiveSchools.vue?vue&type=script&lang=js"
import style0 from "./TopFiveActiveSchools.vue?vue&type=style&index=0&id=4a693e9a&prod&lang=scss&scoped=true"
import style1 from "./TopFiveActiveSchools.vue?vue&type=style&index=1&id=4a693e9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a693e9a",
  null
  
)

export default component.exports